<template>
  <section class="section section--gray">
    <div class="container">
      <div class="section__header section__header--center">
        <span class="section__label">Проблема</span>
        <h2 class="section__title">Премии в Excel — это боль каждый месяц</h2>
        <p class="section__subtitle">Каждый расчётный период — те же ошибки, споры и потерянные дни</p>
      </div>
      <div class="grid-3">
        <div v-for="item in problems" :key="item.title" class="problem-card">
          <div class="problem-card__icon">
            <ui-icon :name="item.icon" :size="26" />
          </div>
          <h3 class="problem-card__title">{{ item.title }}</h3>
          <p class="problem-card__text">{{ item.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UiIcon from '../ui/UiIcon.vue'
export default {
  name: 'ProblemSection',
  components: { UiIcon },
  data() {
    return {
      problems: [
        { icon: 'table',          title: 'Таблицы Excel',         text: 'Формулы ломаются, версии расходятся, а как всё устроено — знает один человек.' },
        { icon: 'alert-triangle', title: 'Ошибки в расчётах',     text: 'Одна ошибка в формуле — и переплата или недоплата уходит по всему отделу.' },
        { icon: 'clock',          title: 'Потери времени',        text: 'HR и бухгалтерия тратят дни на расчёт, который повторяется каждый месяц.' },
        { icon: 'lock',           title: 'Непрозрачность',        text: 'Сотрудник не понимает, из чего сложилась его премия, и не верит цифре.' },
        { icon: 'target',         title: 'KPI живут отдельно',    text: 'Цели и KPI считаете в отдельных таблицах, а в премию переносите вручную — с ошибками и задержками.' },
        { icon: 'users',          title: 'Кто что видит — вручную', text: 'Чтобы руководитель филиала видел только своих, доступ раздаёте руками по каждому сотруднику.' },
      ],
    }
  },
}
</script>

<style scoped>
.problem-card {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 28px;
  transition: var(--transition);
}
.problem-card:hover { box-shadow: var(--shadow); }
.problem-card__icon {
  width: 48px; height: 48px;
  border-radius: 12px;
  background: var(--primary-light);
  color: var(--primary);
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 16px;
}
.problem-card__title {
  font-size: 1.0625rem;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--dark);
}
.problem-card__text { color: var(--gray); font-size: 0.9375rem; line-height: 1.6; }
</style>
